import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Auth } from 'src/providers/auth/auth';
import { Me } from 'src/providers/me/me';

@Injectable()
export class BillsRedirectGuard implements CanActivate {

  constructor(
    private auth: Auth,
    private me: Me,
    private navCtrl: CustomNavController
  ) {}

  async canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    if (!this.auth.isAuthenticated()) {
      return true;
    }

    const accType = await this.me.getAccType();

    // Rental customers should use Finance page instead of Bills
    if (accType === 'rental') {
      this.navCtrl.navigateRoot('finance');
      return false;
    }

    // All other account types (customer, company, etc.) can access Bills
    return true;
  }
}
